import React from 'react'
import { Pressable, StyleSheet, Text, View } from 'react-native'
import { DS } from '@/design-system'
import { translate } from '../../../i18n'

const BLIND_INTERVAL_OPTIONS = [5, 10, 15]

interface BlindIntervalPickerProps {
  value: number | null
  onChange: (minutes: number | null) => void
}

export function BlindIntervalPicker({ value, onChange }: BlindIntervalPickerProps) {
  return (
    <View style={styles.container}>
      <Pressable onPress={() => onChange(null)} style={[styles.pill, value === null && styles.pillSelected]}>
        <Text style={[styles.label, value === null && styles.labelSelected]}>{translate('createGameV2.none')}</Text>
      </Pressable>
      {BLIND_INTERVAL_OPTIONS.map((minutes) => {
        const selected = minutes === value
        return (
          <Pressable
            key={minutes}
            onPress={() => onChange(minutes)}
            style={[styles.pill, selected && styles.pillSelected]}
          >
            <Text style={[styles.label, selected && styles.labelSelected]}>
              {translate('createGameV2.minutesCount', { count: minutes })}
            </Text>
          </Pressable>
        )
      })}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 8
  },
  pill: {
    flex: 1,
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 50,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    alignItems: 'center'
  },
  pillSelected: {
    backgroundColor: DS.palette['Global/Black']
  },
  label: {
    fontSize: 14,
    color: DS.palette['Global/Black']
  },
  labelSelected: {
    color: DS.palette['Global/White']
  }
})
